<template lang="html">
  <el-row>
    <el-col >
      <el-row class="bg-eee pd-tb10 pd-lr10 border-radio10">
        <div class="title" v-html='qdata.content'></div>
        <div class="option">
          <ul>
            <li :class="['activer']">{{qdata.answer}}</li>
          </ul>
        </div>
        <div class="awser">
          答案：{{ answer}}
        </div>
        <div class="analysis">
          解析：{{qdata.analysis}}
        </div>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'Judge',
  props: ['qdata'],
  data () {
    return {
      radio: '1'
    }
  },
  created () {
    console.log(this.qdata)
  },
  filters: {
    answer (val) {
      return val == 0 ? '正确' : '错误'
    }
  }
}
</script>

<style lang="scss" scoped>
.title{
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.awser,.analysis{
  font-size: 14px;
  padding-bottom: 10px;
  padding-left: 5px;
  color: #666;
}
.option{
  font-size: 14px;
  margin: 15px 5px;
  li{
    padding: 10px 0;
    span{
      line-height: 16px;
    }
  }
  li.activer{
    color: #409EFF;
  }

}
.option{
      font-size: 14px;
    margin: 15px 5px;
}
.bg-eee{
      background: #eee;
}
.border-radio10 {
    border-radius: 10px;
}
</style>
